import { useCurrentStateAndParams } from '@uirouter/react';

import { useCurrentUser } from '@/react/hooks/useUser';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { PageHeader } from '@@/PageHeader';

import { ScopedKubeconfigsDatatable } from './components/ScopedKubeconfigsDatatable';
import { useScopedKubeconfigs } from './queries/useScopedKubeconfigs';

/**
 * Scoped kubeconfigs for one environment. The same screen serves everyone: the
 * API returns only your own rows unless you are an administrator, so a normal
 * user and an admin see different data through identical UI.
 */
export function EnvironmentScopedKubeconfigsView() {
  const { params } = useCurrentStateAndParams();
  const environmentId: EnvironmentId = Number(params.endpointId);
  const { isPureAdmin } = useCurrentUser();

  const scopedKubeconfigsQuery = useScopedKubeconfigs(environmentId);

  return (
    <>
      <PageHeader
        title="Kubeconfigs"
        breadcrumbs={[{ label: 'Kubeconfigs' }]}
        reload
      />

      <ScopedKubeconfigsDatatable
        dataset={scopedKubeconfigsQuery.data ?? []}
        isLoading={scopedKubeconfigsQuery.isLoading}
        tableKey="environment-scoped-kubeconfigs"
        showOwner={isPureAdmin}
        showEnvironment={false}
        description={
          isPureAdmin
            ? 'Read-only kubeconfigs issued for this environment, by any user.'
            : 'Read-only kubeconfigs you have been issued for this environment.'
        }
      />
    </>
  );
}
